/** Mirrors the backend DebitMandateStatusContract (serialized as PascalCase strings). */
export enum DebitMandateStatus {
  Pending = "Pending",
  Active = "Active",
  Revoked = "Revoked",
}
